import OperatorSession from "../Models/OperatorSession";
import HttpService from "../Services/HttpService";
import OperatorSettings from "../Models/OperatorSettings";

class OperatorRepository
{
  public operatorSessions: OperatorSession[] = [];

  public async load(): Promise<OperatorSession[]>
  {    
    const url = '/Operator';
    this.operatorSessions = await HttpService.get<OperatorSession[]>(url);
    return this.operatorSessions;
  }

  public async getSettings(): Promise<OperatorSettings>
  {
    const url = '/Operator/Settings';
    return await HttpService.get<OperatorSettings>(url);
  }

  public async updateSettings(request: OperatorSettings): Promise<OperatorSettings>
  {
    const url = '/Operator/Settings';
    return await HttpService.put<OperatorSettings>(url, request);
  }
}

export const operatorRepository = new OperatorRepository();